export default __webpack_public_path__ + "static/media/CNo.65-0.abb8314a.jpg";